import Navbar from "@/components/site/Navbar";
import Portfolio from "@/components/site/Portfolio";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import Clients from "@/components/site/Clients";
import QuoteForm from "@/components/site/QuoteForm";
import Footer from "@/components/site/Footer";

export default function WorkPage() {
  return (
    <main className="bg-[#050505]" data-testid="work-page">
      <Navbar />
      <div className="pt-24 md:pt-28">
        <Portfolio />
      </div>
      <EditorialMarquee />
      <Clients />
      <QuoteForm />
      <Footer />
    </main>
  );
}
